import React, { useState } from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { SolutionSection } from './SolutionSection';
import { HeadlinesShowcase } from './HeadlinesShowcase';
import { TermsPage } from './TermsPage';
export function SalesPage() {
  const [showTerms, setShowTerms] = useState(false);
  if (showTerms) {
    return <TermsPage onBack={() => {
      setShowTerms(false);
      window.scrollTo(0, 0);
    }} data-id="element-35" />;
  }
  return <div className="min-h-screen bg-[#1E1B19] font-sans selection:bg-[#C5A55A] selection:text-[#1E1B19]" data-id="element-36">
      {/* Navigation / Brand Header */}
      <nav className="py-6 px-6 text-center border-b border-[#3A3330]" data-id="element-37">
        <div className="font-serif text-2xl font-bold text-[#F5F0EB] tracking-tight" data-id="element-38">
          El Método del <span className="text-[#C5A55A]" data-id="element-39">Látex</span>
        </div>
      </nav>

      <main data-id="element-40">
        <HeroSection data-id="element-41" />
        <PainSection data-id="element-42" />
        <SolutionSection data-id="element-43" />

        {/* Divider */}
        <div className="max-w-xs mx-auto h-px bg-gradient-to-r from-transparent via-[#C5A55A]/30 to-transparent my-8" data-id="element-44"></div>

        {/* Bonus Section: Ad Strategy Showcase */}
        <HeadlinesShowcase data-id="element-45" />
      </main>

      <footer className="bg-[#151210] text-[#7A6F64] py-12 px-6 text-center text-sm border-t border-[#3A3330]" data-id="element-46">
        <div className="max-w-2xl mx-auto space-y-6" data-id="element-47">
          <div className="font-serif text-xl text-[#C5A55A]" data-id="element-48">
            El Método del Látex
          </div>
          <p data-id="element-49">© {new Date().getFullYear()} Todos los derechos reservados.</p>
          <div className="flex justify-center gap-6 text-xs uppercase tracking-widest" data-id="element-50">
            <button onClick={() => {
            setShowTerms(true);
            window.scrollTo(0, 0);
          }} className="hover:text-[#C5A55A] transition-colors" data-id="element-51">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>
    </div>;
}